import React, {useState, useEffect, useMemo} from "react";
import {useNavigate} from "react-router-dom";
import {toast, ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Layout from "../components/Layout/Layout";
import SecondPageTopSection from "../components/TopSection/SecondPageTopSection";
import ContactSection from "../components/ContactSection/ContactSection";
import {BusinessService} from "../services/business-service";
import {StoreService} from "../services/store-service";
import {getCategories} from "../services/server-actions";

import BgImage from "../assets/Bg.webp";
import DefaultLogo from "../assets/images/logo.png";
import {
    MobileBusinessProfileDto,
    PasswordlessLoginProviderType,
} from "../services/shared/service-proxies/service-proxies";

const MobileVerifyPage: React.FC = () => {
    const navigate = useNavigate();
    const businessService = useMemo(() => new BusinessService(), []);

    const [accessToken, setAccessToken] = useState<string | null>(null);
    const [profile, setProfile] = useState<MobileBusinessProfileDto>(new MobileBusinessProfileDto());
    const [phoneNumber, setPhoneNumber] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);

    const businessProfile = StoreService.GetData("business-profile");
    const logo = businessProfile?.logo || DefaultLogo;
    const bgImage = businessProfile?.background || BgImage;

    const title = businessProfile?.name || "سالن زیبایی میناراد";
    const description = profile?.slogan || "لاین زیبایی";

    useEffect(() => {
        const fetchData = async () => {
            try {
                const profileResult = await businessService.getProfile("Default");
                setProfile(profileResult);
                const token = StoreService.GetData("accessKey");
                if (token) setAccessToken(token);
            } catch (error) {
                toast.error("خطا در دریافت اطلاعات پروفایل یا توکن دسترسی");
            }
        };
        fetchData();
    }, [businessService]); // ✅ اضافه کردن `businessService` به وابستگی‌ها

    useEffect(() => {
        if (!accessToken) return;
        const fetchCategories = async () => {
            try {
                const categories = StoreService.GetData("categories");
                if (!categories) {
                    const fetchedCategories = await getCategories(accessToken);
                    StoreService.SetData("categories", fetchedCategories);
                }
            } catch (error) {
                toast.error("خطا در دریافت دسته‌بندی‌ها");
            }
        };
        fetchCategories();
    }, [accessToken]);

    const validatePhoneNumber = (number: string): boolean => {
        const phoneRegex = /^09\d{9}$/;
        return phoneRegex.test(number);
    };

    const handleContinue = async () => {
        if (!phoneNumber) {
            toast.warn("لطفا شماره تلفن را وارد کنید.");
            return;
        }

        if (!validatePhoneNumber(phoneNumber)) {
            toast.error("شماره وارد شده معتبر نیست.");
            return;
        }

        try {
            setLoading(true);
            await businessService.sendPasswordlessLoginCode(phoneNumber);
            toast.success("کد تأیید با موفقیت ارسال شد.", {theme: "colored"});
            setTimeout(() => {
                navigate("/verify-otp", {
                    state: {mobile: phoneNumber, providerType: PasswordlessLoginProviderType.Sms},
                });
                setLoading(false);
            }, 2500);
        } catch (error) {
            toast.error("شماره تلفن صحیح نیست.");
            setLoading(false);
        }
    };

    return (
        <>
            <div style={{height: "100vh", display: "flex", flexDirection: "column"}}>
                <div style={{flex: "0 0 55%", position: "relative", zIndex: 1}}>
                    <SecondPageTopSection
                        backgroundImage={bgImage}
                        logoImage={logo}
                        title={title}
                        description={description}
                        customStyles={{container: {height: "100%"}}}
                    />
                </div>

                <div
                    style={{
                        flex: 1,
                        backgroundColor: "#FFFFFF",
                        borderRadius: "50px 50px 0 0",
                        marginTop: "-40px",
                        padding: "20px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 10,
                    }}
                >
                    <p style={{
                        color: "#555",
                        marginBottom: "10px",
                        fontSize: "16px",
                        textAlign: "center",
                        width: "100%"
                    }}>
                        لطفا برای ادامه شماره تلفن خود را وارد کنید.
                    </p>

                    <input
                        type="tel"
                        inputMode="numeric"
                        placeholder="09*********"
                        className="form-control"
                        style={{
                            width: "90%",
                            height: "50px",
                            textAlign: "center",
                            fontSize: "16px",
                            borderRadius: "8px",
                            marginBottom: "16px",
                        }}
                        value={phoneNumber}
                        onChange={(e) => setPhoneNumber(e.target.value)}
                    />

                    <button
                        className="btn btn-primary"
                        style={{
                            width: "90%",
                            height: "50px",
                            borderRadius: "24px",
                            fontSize: "16px",
                            fontWeight: "bold",
                            backgroundColor: "#695CD5",
                        }}
                        onClick={handleContinue}
                        disabled={loading}
                    >
                        {loading ? "در حال ارسال..." : "ادامه"}
                    </button>

                    <hr style={{margin: "24px auto", width: "70%", borderColor: "#ccc", opacity: 0.6}}/>

                    <ContactSection/>
                </div>
            </div>

            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={true}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />
        </>
    );
};

export default MobileVerifyPage;
